import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IndicatorsModule } from '@shared/core/components/indicators';
import { IconModule } from '@shared/core/components/icon';
import { QuantityModule } from '@shared/core/components/quantity';
import { ThumbsModule } from '@shared/core/components/thumbs';
import { HeadersModule } from '@shared/core/components/headers';
import { QuickSelectorModule } from '@shared/core/components/quickSelector';

import { TileForWizzardComponent } from './tile-for-wizzard.shared.component';

@NgModule({
    declarations: [
        TileForWizzardComponent
    ],
    imports: [
        CommonModule,
        ThumbsModule,
        HeadersModule,
        QuantityModule,
        IconModule,
        IndicatorsModule,
        QuickSelectorModule,
    ],
    exports: [
        TileForWizzardComponent
    ],
    providers: [],
})
export class TileForWizzardModule { }
